// extracted by mini-css-extract-plugin
export default {"products":"Nu-z","card":"Ou-z","oosMessaging":"Pu-z"};